const LoadFromLocalStorage = (item, key, setter) => {
  if(item != null && window.isLocalStorageSupported && window.isLocalStorageSupported()) {
    let storageKey = (window.getAttrKeyForNesting) ? window.getAttrKeyForNesting(key, item.uuid) : `${item.uuid}_${key}`;
    let value = localStorage.getItem(storageKey);
    if(value != null && value !== "null" && value !== "undefined" && value !== "") {
      setter(value);
    }
  }
}
export default LoadFromLocalStorage;
